import { inventoryTypes } from "redux/reducers/inventories/types"
import { PROYECT } from "services/api"
import { api_get } from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"
import { api_post } from "services/api"
import { api_put } from "services/api"
import { convertKeysToCamelCase } from "helpers/remapingKeysToCamel"
import { getShipmentsInventory } from "./inventShipmentsActions"
import { inventoryDictionary } from "helpers/dictionary"

export const {
  INVENTORIES_INPUTS_FILTERS,

  GET_INVENTORIES,
  GET_INVENTORY_BY_ID,
  SET_INVENTORY_DATA_BY_TYPE,
  GET_INVENTORY_EXISTENCE,
  CREATE_GENERAL_INVENTORY,

  SAVE_INVENTORY,

  GET_STORAGES,
  SELECT_INVENTORY,
  UPDATE_INVENTORY_PERCENTAGE,
  STATION_SELECTED,
  UPDATE_UNIT_CIL,
  SET_INVENTORY_DATA,
  CLOSE_DELETE_INVENTORY,

  SET_CONFIG_PAGE_INVENTORIES,
  SET_CONFIG_PAGE_INVENTORIES_COUNT,
  SET_CONFIG_SORTED_INVENTORIES,
  SET_CONFIG_FILTERED_INVENTORIES,
  RESET_TABLE_CONTROLS,
  RESET_NEW_INVENTORY_MODE,
  SET_MOBILE_ENDOWMENTS,
  REOPEN_INVENTORY,
  REOPEN_CPV,
  RESTORE_INVENTORY_SAVE,
  MARK_INVENTORY_LOADED,
  UPDATE_DIGITAL_STATUS,
  GET_INVENTORY_CONFIG
} = inventoryTypes

const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`
const mainUrl = `${baseUrl}/station-inventory`

export const filtersInventories = (form) => {
  return {
    // type: INVENTORY_STATION,
    payload: form
  }
}

export const inventoriesSearchInputs = (key = '', value) => {
  return {
    type: INVENTORIES_INPUTS_FILTERS,
    payload: { key, value }
  }
}

export const getInventories = (startDate, endDate, station) => {
  const urlCpv = `${mainUrl}/cpv_status/${station}`
  // const url = `${mainUrl}?start=2026-03-01&end=2026-04-30&stations=${station || '7249c09c-55fd-4ef1-8ba4-bdfced4ed385'}`
  const url = `${mainUrl}?start=${startDate}&end=${endDate}&stations=${station}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventories'))

    const isCpv = await api_get(urlCpv)
    await api_get(url).then(res => {
      dispatch({
        type: GET_INVENTORIES,
        payload: res.map(r => {
          return { ...r, isCpv: isCpv }
        })
      })
      dispatch(stopRequestComp('loadingInventories'))
    }).catch(err => {
      dispatch(stopRequestComp('loadingInventories'))
      dispatch(setSnackbar(err))
    })
  }
}

export const getInventory = ({
  inventoryId, navigation, stationId
}) => {
  const url = `${mainUrl}/${inventoryId}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventory'))
    await api_get(url).then(res => {
      dispatch({
        type: GET_INVENTORY_BY_ID,
        payload: res
      })
      dispatch(getShipmentsInventory(inventoryId))
      dispatch(getInventoryConfig(stationId))
      dispatch(stopRequestComp('loadingInventory'))
      navigation && navigation(inventoryId)
    }).catch(err => {
      dispatch(stopRequestComp('loadingInventory'))
      dispatch(setSnackbar(err))
    })
  }
}

export const getInventoryByType = (id = "", type = "", keyInventory = "", units = null, tanks = null) => {
  const url = `${mainUrl}/${id}/recover-units/${keyInventory}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventoryType'))
    await api_get(url).then(res => {
      const data = res.flat().map(item => convertKeysToCamelCase(item))
      let keyTanksData = []
      if (keyInventory == "localInventory") {
        keyTanksData = data.map(tank => {
          return {
            ...tank,
            unitNumber: units ? units[tanks[tank.idTank].id_unit]?.number : ""
          }
        })
      }
      dispatch({
        type: SET_INVENTORY_DATA_BY_TYPE,
        payload: {
          keyInventory,
          data: keyTanksData.length > 0 ? keyTanksData : data
        }
      })
      dispatch(saveInventory(id, type, data, keyInventory, true, true))
      dispatch(stopRequestComp('loadingInventoryType'))
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loadingInventoryType'))
    })
  }
}
export const getInventoryExistence = (id, isCpv = false) => {
  const url = `${mainUrl}/${id}/existance`
  const urlCpv = `${mainUrl}/cpv/${id}`
  return async dispatch => {
    dispatch(startRequestComp('loadingInventoryExistence'))
    try {
      if (isCpv) {
        await api_post(urlCpv).then(res => {
          dispatch({
            type: GET_INVENTORY_EXISTENCE,
            payload: res[0]
          })
          dispatch(setSnackbar("CPV Éxitoso", "success"))

        })
      } else {
        await api_get(url).then(res => {
          dispatch({
            type: GET_INVENTORY_EXISTENCE,
            payload: res[0]
          })
          dispatch(setSnackbar("Recalculo éxitoso", "success"))
        })
      }
    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp('loadingInventoryExistence'))
  }
}

export const reopenCPV = (id) => {
  const url = `${mainUrl}/support/revert-cpv/${id}`;
  return async dispatch => {
    dispatch(startRequestComp('loadingInventoryExistence'))
    try {
      await api_put(url).then(res => {
        dispatch({
          type: REOPEN_CPV,
          payload: id
        })
        dispatch(setSnackbar(res.message, "success"))
      })
    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp('loadingInventoryExistence'))
  }
}

export const createGeneralInventory = (form, stations, units, onClose) => {
  return async dispatch => {
    dispatch(startRequestComp('loadingGeneralInventory'))
    const urlCpv = `${mainUrl}/cpv_status/${form.idStation}`
    const isCpv = await api_get(urlCpv)
    await api_post(mainUrl, form).then(res => {
      dispatch({
        type: CREATE_GENERAL_INVENTORY,
        payload: { ...res, isNew: true, isCpv: isCpv }
      })
      dispatch(stopRequestComp('loadingGeneralInventory'))
      dispatch(getInventory({
        inventoryId: res.id,
        navigation: onClose,
        stationId: form.idStation
      }))
      dispatch(setSnackbar("Inventario creado", "success"))
    }).catch(err => {
      dispatch(stopRequestComp('loadingGeneralInventory'))
      dispatch(setSnackbar(err))
    })
  }
}

export const getInventoryMobileEndowments = (idStation, units) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/endowments/mobile?stations=${idStation}`
  return async dispatch => {
    await api_get(url).then(resp => {
      const addUnitNumber = resp.map(unit => {
        return {
          ...unit,
          number: units[unit.idUnit].number,
          totalKg: unit.cil10 + unit.cil20 + unit.cil30 + unit.cil45
        }
      })
      dispatch({ type: SET_MOBILE_ENDOWMENTS, payload: addUnitNumber })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
  }
}

export const resetIsNewInventory = () => {
  return {
    type: RESET_NEW_INVENTORY_MODE,
  }
}
export const saveInventory = (id, type, form, keyInventory, hideSnackbar = false) => {
  const url = `${mainUrl}/${id}/${type}`
  return async dispatch => {
    dispatch(startRequestComp('loadingSavingInventory'))
    await api_post(url, form).then(res => {
      dispatch({
        type: SAVE_INVENTORY,
        payload: { data: res, key: keyInventory }
      })
      !hideSnackbar && dispatch(setSnackbar("Inventario guardado", "success"))
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingSavingInventory'))
  }
}

export const getStorages = (idStation) => {
  return async dispatch => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/storages?stations=${idStation}`
    await api_get(url).then(res => {
      dispatch({
        type: GET_STORAGES,
        payload: res
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
  }
}

export const selectInventory = (data) => {
  return {
    type: SELECT_INVENTORY,
    payload: data
  }
}

export const updatePercentageInventory = (inventoryType, idUnit, percentage) => {
  return {
    type: UPDATE_INVENTORY_PERCENTAGE,
    payload: { inventoryType, idUnit, percentage }
  }
}

export const updateUnitCil = (idUnit, key, cil) => {
  return {
    type: UPDATE_UNIT_CIL,
    payload: { idUnit, key, cil }
  }
}
export const tankCounter = (data) => {
  return {
    type: '',
    payload: data
  }
}

export const closeDeleteInventory = (id, del = true, nav = null) => {
  const url = `${mainUrl}/${id}/status?${del ? 'registry=DELETED' : 'inventory=CLOSED'}`
  return async dispatch => {
    await api_put(url).then(resp => {
      dispatch({
        type: CLOSE_DELETE_INVENTORY,
        payload: { id, del }
      })
      nav && nav()
      dispatch(setSnackbar(`Inventario ${del ? "eliminado" : "cerrado"}`, "success"))
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
  }
}

export const setInventoryData = (value, key) => {
  return {
    type: SET_INVENTORY_DATA,
    payload: { key, value }
  }
}
export const setConfigFilteredInventories = (key = "", data) => {
  return {
    type: SET_CONFIG_FILTERED_INVENTORIES,
    payload: {
      key, data
    }
  }
}


export const setConfigSortedInventories = (key = "", data) => {
  return {
    type: SET_CONFIG_SORTED_INVENTORIES,
    payload: {
      key, data
    }
  }
}

export const setConfigPageInventoriesCount = (key = "", data) => {
  return {
    type: SET_CONFIG_PAGE_INVENTORIES_COUNT,
    payload: {
      key, data
    }
  }
}

export const setConfigPageInventories = (key = "", data) => {
  return {
    type: SET_CONFIG_PAGE_INVENTORIES,
    payload: {
      key, data
    }
  }
}

export const resetTableControls = () => {
  return {
    type: RESET_TABLE_CONTROLS,
  }
}

export const reopenInventoryAction = (id, action = null) => {
  const url = `${mainUrl}/support/open-manual/${id}`
  return async dispatch => {
    dispatch(startRequestComp('loadingReopenInventory'))
    await api_put(url).then(_ => {
      dispatch(setSnackbar("Inventario reabierto", "success"))
      dispatch({
        type: REOPEN_INVENTORY,
        payload: id
      })
      action && action()
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingReopenInventory'))
  }
}

export const updateInventoryDigital = (idInventory, body, edited, action = null) => {
  const url = `${mainUrl}/edit-digital-percentage/${idInventory}`
  return async dispatch => {
    startRequestComp("loadingUpdateDigitalInventory")
    await api_put(url, body).then(resp => {
      dispatch(setSnackbar(resp, "success"))
      dispatch({
        type: UPDATE_DIGITAL_STATUS,
        payload: { id: body.id, keyInventory: body.keyInventory }
      })
      dispatch({ type: RESTORE_INVENTORY_SAVE, payload: edited })
      action && action()
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp("loadingUpdateDigitalInventory"))
  }
}

export const markInventoryLoaded = (key) => {
  return {
    type: MARK_INVENTORY_LOADED,
    payload: key
  }
}

export const getInventoryConfig = (id) => {
  return async dispatch => {
    dispatch(startRequestComp("inventoryConf"))
    const url = `${baseUrl}/stations/inventory_config/${id}`

    await api_get(url).then(resp => {
      dispatch({
        type: GET_INVENTORY_CONFIG,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp("inventoryConf"))
  }
}